<template>
    <label :for="id" :class="['flex gap-3', compact ? 'items-center' : 'items-start justify-between', { 'opacity-50': disabled }]">
        <span :class="[bold ? 'font-semibold' : '']">{{ label }}</span>
        <BaseSwitch :id="id" v-model="value" :disabled="disabled" :style="value && checkedColor ? { backgroundColor: checkedColor } : undefined" />
    </label>
</template>

<script setup lang="ts">
import BaseSwitch from "~vue/components/BaseSwitch.vue";

interface Props {
    id: string;
    disabled?: boolean;
    label: string;
    bold?: boolean;
    compact?: boolean;
    checkedColor?: string;
}

const value = defineModel<boolean>({ required: true });

withDefaults(defineProps<Props>(), {
    disabled: false,
    bold: false,
    compact: false,
});
</script>
